import {EVENT_TYPE_PAGELOAD}from'./constants.js';var getAnalytics = function getAnalytics() {
  var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var DEFAULT_CWC_MLCA = {
    dataLayer: {
      actions: []
    }
  };
  if (clear) {
    window.CWC_MLCA = DEFAULT_CWC_MLCA;
  } else {
    window.CWC_MLCA = window.CWC_MLCA || DEFAULT_CWC_MLCA;
  }
  return window.CWC_MLCA;
};

/**
 * Records a page loading event for adobe analytics
 *
 * @param {string} language The name of the event
 * @param {string} pageName The name of the action
 * @param {string} pageTitle Additional data to record
 */

var recordPageLoad = function recordPageLoad(language, pageName, pageTitle, userType, hashedCiamId, otcChannel) {
  var analytics = getAnalytics();
  var page = {
    name: pageName || '',
    language: language || '',
    title: pageTitle || ''
  };
  var user = {
    type: userType,
    id: hashedCiamId
  };
  var dataLayer = {
    event: EVENT_TYPE_PAGELOAD,
    page: page,
    user: user,
    otc: {
      channel: otcChannel
    }
  };
  analytics.dataLayer.push(dataLayer);
};
var recordEvent = function recordEvent(eventName, userType, hashedCiamId, labelField) {
  var analytics = getAnalytics();
  var user = {
    type: userType,
    id: hashedCiamId
  };
  var dataLayer = {
    event: eventName,
    action: {
      label: labelField
    },
    user: user
  };
  dataLayer.user = user;
  analytics.dataLayer.push(dataLayer);
};
var recordError = function recordError(eventName, eventError) {
  var analytics = getAnalytics();
  var errorCode = eventError.errorCode,
    description = eventError.description;
  var dataLayer = {
    event: eventName
  };
  var error = {
    code: errorCode,
    // code of error that occurred
    type: 'user',
    // type of error that occurred, usually "user" or "server"
    description: description
  };
  dataLayer.error = error;
  analytics.dataLayer.push(dataLayer);
};
var clearPageInfo = function clearPageInfo() {
  var analytics = getAnalytics(false);
  analytics.dataLayer.page = {
    name: '',
    language: '',
    title: ''
  };
};
var DataLayerOperation = {
  getAnalytics: getAnalytics,
  recordPageLoad: recordPageLoad,
  recordEvent: recordEvent,
  recordError: recordError,
  clearPageInfo: clearPageInfo
};export{DataLayerOperation as default};